import React from "react";
import PropTypes from "prop-types";

import styles from "./Label.module.scss";
import clsx from "clsx";

const Label = ({
  color,
  children,
  htmlFor,
  onClick,
  required,
  disabled,
  dataTestId,
  type,
  className,
}) => {
  const labelClasses = clsx(styles.label, className, {
    "text-primary-500": !disabled && color === "primary",
    "text-success-500": !disabled && color === "success",
    "text-secondary-500": !disabled && color === "secondary",
    "text-warning-500": !disabled && color === "warning",
    [`${color}`]: !disabled && !!color,
    [styles.disabled]: disabled,
    [styles.large]: type && String(type).toLowerCase() === "large",
  });

  return (
    <label
      className={labelClasses}
      data-testid={dataTestId}
      onClick={() => {
        if (!disabled && typeof onClick === "function") {
          onClick();
        }
      }}
      htmlFor={htmlFor}
    >
      {required && <span className={styles.required}>* </span>}
      {children}
    </label>
  );
};

Label.defaultProps = {
  color: "default",
  htmlFor: "",
  required: false,
  type: "",
};

Label.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  dataTestId: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Label;
